import { render, staticRenderFns } from "./gatewayAdd.vue?vue&type=template&id=09f96bd8&scoped=true&"
import script from "./gatewayAdd.vue?vue&type=script&lang=js&"
export * from "./gatewayAdd.vue?vue&type=script&lang=js&"
import style0 from "./gatewayAdd.vue?vue&type=style&index=0&id=09f96bd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f96bd8",
  null
  
)

export default component.exports